import React from 'react'
import clsx from 'clsx'
import * as Yup from 'yup'

import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  makeStyles,
} from '@material-ui/core'
import {
  withStyles,
} from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'
// import { orange } from '@material-ui/core/colors'
import { changePass } from '../../../app/slices/userSlice'

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(TextField)

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: '20px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
    },
  },
  MuiPaper: {
    root: {
      MuiMenu: {
        paper: {
          borderRadius: '50px',

        },
      },

    },
  },
}))

const ChangePassword = ({ className, ...rest }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const loggedInUser = useSelector((state) => state.user)

  return (
    <Formik
      initialValues={{
        username: loggedInUser.userName,
        currentPassword: '',
      }}
      validationSchema={Yup.object().shape({
        // email: Yup.string().email('Must be a valid email')
        // .max(255).required('Email is required'),
        username: Yup.string()
          .max(255).required('نام کاربری ضروری است'),
        currentPassword: Yup.string()
          .max(255).required('رمز عبور ضروری است'),
        newPassword: Yup.string()
          .min(8, 'رمز عبور باید حداقل ۸ کاراکتر باشد')
          .max(255).required('رمزعبور جدید ضروری است'),
        newPasswordConfirm: Yup.string()
          .min(8, 'رمز عبور باید حداقل ۸ کاراکتر باشد')
          .max(255).required('تکرار رمزعبور جدید ضروری است')
          .oneOf([Yup.ref('newPassword'), null], 'رمزعبور جدید و تکرار آن باید یکی باشند'),

      })}
      onSubmit={(values, formikBag) => {
        dispatch(changePass({
          UserName: values.username,
          OldPassword: values.currentPassword,
          NewPassword: values.newPassword,
        }, () => formikBag.setSubmitting(false)))
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          autoComplete="off"
          noValidate
          className={clsx(classes.root, className)}
          onSubmit={handleSubmit}
          {...rest}
        >
          <Card className={classes.root}>
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <CssTextField
                    error={Boolean(touched.username && errors.username)}
                    fullWidth
                    helperText={touched.username && errors.username}
                    label="نام کاربری(کد ملی)"
                    margin="normal"
                    name="username"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.username}
                    variant="outlined"
                    disabled
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <CssTextField
                    error={Boolean(touched.currentPassword && errors.currentPassword)}
                    fullWidth
                    helperText={touched.currentPassword && errors.currentPassword}
                    label="رمز عبور فعلی"
                    margin="normal"
                    name="currentPassword"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="password"
                    value={values.currentPassword}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <CssTextField
                    error={Boolean(touched.newPassword && errors.newPassword)}
                    fullWidth
                    helperText={touched.newPassword && errors.newPassword}
                    label="رمز عبور جدید"
                    margin="normal"
                    name="newPassword"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="password"
                    value={values.newPassword}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <CssTextField
                    error={Boolean(touched.newPasswordConfirm && errors.newPasswordConfirm)}
                    fullWidth
                    helperText={touched.newPasswordConfirm && errors.newPasswordConfirm}
                    label="تکرار رمز عبور جدید"
                    margin="normal"
                    name="newPasswordConfirm"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="password"
                    value={values.newPasswordConfirm}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Box
              display="flex"
              justifyContent="flex-end"
              p={2}
            >
              <Button
                color="primary"
                disabled={isSubmitting}
                size="large"
                type="submit"
                variant="contained"
              >
                ذخیره
              </Button>
            </Box>
          </Card>
        </form>
      )}
    </Formik>
  )
}

ChangePassword.propTypes = {
  className: PropTypes.string,
}

export default ChangePassword
